import { IconPrefixes } from '../../constants/hmds.constants';
import { AssessmentStatus } from './due-date-progress.models';

const completedConfig = {
  name: 'checkmark',
  prefix: IconPrefixes.HMDS,
}

export const iconConfigMap: Record<AssessmentStatus, { name: string; prefix: string }> = {
  [AssessmentStatus.IN_PROGRESS_NOT_DUE]: null,
  [AssessmentStatus.IN_PROGRESS_DUE]: null,
  [AssessmentStatus.COMPLETED_ON_TIME]: completedConfig,
  [AssessmentStatus.COMPLETED_LATE]: completedConfig,
  [AssessmentStatus.COMPLETED_NOT_DUE]: completedConfig,
  [AssessmentStatus.IN_PROGRESS_PAST_DUE]: {
    name: 'alert',
    prefix: IconPrefixes.GIZMO,
  }
}
